'use client';

import { useEffect } from 'react';

const updateAppHeight = () => {
  const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
  document.documentElement.style.setProperty(
    '--app-height',
    `${viewportHeight}px`
  );
};

export default function AppHeightSetter() {
  useEffect(() => {
    updateAppHeight();
    window.addEventListener('resize', updateAppHeight);
    window.visualViewport?.addEventListener('resize', updateAppHeight);
    return () => {
      window.removeEventListener('resize', updateAppHeight);
      window.visualViewport?.removeEventListener('resize', updateAppHeight);
    };
  }, []);
  return null;
}
